import TableText from "@/components/common/TableText";
import { Eye, Pencil, Trash2, Navigation, Link2 } from "lucide-react";

export const getBaseNavigationColumns = ({ onView, onEdit, onDelete }) => [
  {
    key: "BaseNavigationName",
    label: "Navigation",
    width: "280px",

    render: (row) => (
      <div
        onClick={() => onView(row)}
        className="
          flex items-center gap-3 min-w-0
          cursor-pointer
          rounded-lg
          p-2
          -m-2
          transition-all
          hover:bg-slate-50
          dark:hover:bg-slate-800
        "
      >
        <div className="w-10 h-10 shrink-0 rounded-xl bg-cyan-500/10 flex items-center justify-center">
          <Navigation className="w-5 h-5 text-cyan-500" />
        </div>

        <div className="min-w-0 w-0 flex-1">
          <TableText
            title={row.BaseNavigationName}
            subtitle={row.BaseNavigationURL || "No URL"}
            multiline
            maxLines={2}
          />
        </div>
      </div>
    ),
  },

  {
    key: "AccountTypeName",
    label: "Account Type",

    render: (row) => (
      <span
        className="
          px-2.5 py-1
          rounded-full
          text-xs
          font-medium
          bg-blue-500/10
          text-blue-600
          dark:text-blue-400
        "
      >
        {row.AccountTypeName}
      </span>
    ),
  },

  {
    key: "BaseNavigationURL",
    label: "URL",

    render: (row) => (
      <div className="flex items-center gap-2 max-w-xs">
        <Link2 className="w-4 h-4 text-slate-400 shrink-0" />

        <span
          className="
            truncate
            text-sm
            text-slate-600
            dark:text-slate-300
          "
          title={row.BaseNavigationURL}
        >
          {row.BaseNavigationURL}
        </span>
      </div>
    ),
  },

  {
    key: "SequenceNo",
    label: "Sequence",
    width: 100,

    render: (row) => (
      <span className="font-medium text-slate-900 dark:text-white">
        {row.SequenceNo}
      </span>
    ),
  },

  {
    key: "HasNavigation",
    label: "Linked",
    width: 120,

    render: (row) => (
      <span
        className={`px-2.5 py-1 rounded-full text-xs font-medium ${
          row.HasNavigation
            ? "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
            : "bg-amber-500/10 text-amber-600 dark:text-amber-400"
        }`}
      >
        {row.HasNavigation ? "Yes" : "No"}
      </span>
    ),
  },

  {
    key: "IsActive",
    label: "Status",
    width: 100,

    render: (row) => (
      <span
        className={`px-2.5 py-1 rounded-full text-xs font-medium ${
          row.IsActive
            ? "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
            : "bg-red-500/10 text-red-600 dark:text-red-400"
        }`}
      >
        {row.IsActive ? "Active" : "Inactive"}
      </span>
    ),
  },

  {
    key: "CreatedOn",
    label: "Created On",
    width: 140,

    render: (row) => (
      <span className="text-sm text-slate-600 dark:text-slate-300">
        {row.CreatedOn
          ? new Date(row.CreatedOn).toLocaleDateString("en-IN")
          : "-"}
      </span>
    ),
  },

  {
    key: "actions",
    label: "Actions",

    render: (row) => (
      <div className="flex items-center gap-2">
        <button
          onClick={() => onView(row)}
          className="
            p-2
            rounded-lg
            hover:bg-slate-100
            dark:hover:bg-slate-800
            transition-colors
          "
          title="View"
        >
          <Eye className="w-4 h-4 text-slate-600 dark:text-slate-300" />
        </button>

        <button
          onClick={() => onEdit(row)}
          className="
            p-2
            rounded-lg
            hover:bg-slate-100
            dark:hover:bg-slate-800
            transition-colors
          "
          title="Edit"
        >
          <Pencil className="w-4 h-4 text-blue-500" />
        </button>

        <button
          onClick={() => onDelete(row)}
          className="
            p-2
            rounded-lg
            hover:bg-slate-100
            dark:hover:bg-slate-800
            transition-colors
          "
          title={row.IsActive ? "Deactivate" : "Activate"}
        >
          <Trash2 className="w-4 h-4 text-amber-500" />
        </button>
      </div>
    ),
  },
];
